import { css, polished } from 'jimu-core';
export const modalStyles = (props) => {
    var _a, _b;
    const theme = props.theme;
    const modalVars = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.modal;
    return modalVars && css `
    &.modal-dialog {
      position: relative;
      width: auto;
      margin: ${modalVars.dialog.margin};
      pointer-events: none;

      .modal.fade & {
        transition:${modalVars.transition};
        transform: translate(0, -25%);
      }
      .modal.show & {
        transform: translate(0, 0);
      }
    }

    &.modal-dialog-centered {
      display: flex;
      align-items: center;
      min-height: calc(100% - (${modalVars.dialog.margin} * 2));
      &::before {
        display: block;
        height: calc(100vh - (${modalVars.dialog.margin} * 2));
        content: "";
      }
    }

    .modal-content {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      pointer-events: auto;
      background-color: ${modalVars.content.bg};
      background-clip: padding-box;
      border: ${modalVars.content.border.width} solid ${modalVars.content.border.color};
      border-radius: ${modalVars.content.borderRadius};
      box-shadow: ${modalVars.content.shadow};
      outline: 0;
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${modalVars.header.paddingY} ${modalVars.header.paddingX};
      border-bottom: ${modalVars.header.border.width} solid ${modalVars.header.border.color};
      ${polished.borderRadius('top', (_b = modalVars.content.borderRadius) !== null && _b !== void 0 ? _b : 0)};

      .close {
        padding: ${modalVars.header.paddingY} ${modalVars.header.paddingX};
        margin: -${modalVars.header.paddingY} -${modalVars.header.paddingX} -${modalVars.header.paddingY} auto;
      }
    }

    .modal-title {
      flex: 1;
      margin-bottom: 0;
      line-height: ${modalVars.title.lineHeight};
    }

    .modal-body {
      position: relative;
      flex: 1 1 auto;
      padding: ${modalVars.innerPadding};
    }

    .modal-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: ${modalVars.innerPadding};
      border-top: ${modalVars.footer.border.width} solid ${modalVars.footer.border.color};

      > * + * { margin-left: .5rem; }
      > .btn {
        min-width: ${modalVars.footer.button.minWidth};
      }
    }

    .modal-scrollbar-measure {
      position: absolute;
      top: -9999px;
      width: 50px;
      height: 50px;
      overflow: scroll;
    }

    /* TODO: use break points from config */
    @media (min-width: 576px) {
      &.modal-dialog {
        max-width: ${modalVars.sizes.md};
        margin: ${modalVars.dialog.marginYSmUp} auto;
      }
      &.modal-dialog-centered {
        min-height: calc(100% - (${modalVars.dialog.marginYSmUp} * 2));
      }
      &.modal-dialog-centered::before {
        height: calc(100vh - (${modalVars.dialog.marginYSmUp} * 2));
      }
      .modal-content {
        box-shadow: ${modalVars.content.shadowSmUp};
      }
    }

  `;
};
